module.exports = __webpack_public_path__ + "img/TINBOT_LOGO.b820b829.png";